'use client'

import { useState, useEffect } from 'react'

interface CountdownTimerProps {
  variant?: 'light' | 'dark'
}

export default function CountdownTimer({ variant = 'light' }: CountdownTimerProps) {
  const [mounted, setMounted] = useState(false)
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  })

  useEffect(() => {
    setMounted(true)
    const endTime = Date.now() + 24 * 60 * 60 * 1000

    const tick = () => {
      const distance = endTime - Date.now()
      if (distance > 0) {
        setTimeLeft({
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        })
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
      }
    }

    tick()
    const timer = setInterval(tick, 1000)
    return () => clearInterval(timer)
  }, [])

  const isDark = variant === 'dark'
  const items = [
    { value: timeLeft.hours, label: 'Годин' },
    { value: timeLeft.minutes, label: 'Хвилин' },
    { value: timeLeft.seconds, label: 'Секунд' }
  ]

  return (
    <div className="flex items-center justify-center space-x-2.5 md:space-x-3">
      {items.map((item, i) => (
        <div key={i} className="flex flex-col items-center">
          <div
            className={`rounded-xl md:rounded-2xl px-3 md:px-4 py-2.5 md:py-3 min-w-[60px] md:min-w-[72px] text-center font-montserrat-alt ${
              isDark
                ? 'bg-white/10 text-cream'
                : 'bg-purple/10 text-deep'
            }`}
          >
            <div className="text-2xl md:text-3xl font-bold tabular-nums">
              {mounted ? String(item.value).padStart(2, '0') : '--'}
            </div>
          </div>
          <span className={`text-xs md:text-sm mt-1 md:mt-1.5 font-montserrat-alt ${isDark ? 'text-cream/70' : 'text-mauve'}`}>
            {item.label}
          </span>
        </div>
      ))}
    </div>
  )
}
